// `$rootScope.showAlert(description, okLabel, size)` (`app.ng1.ts:525`) — a plain Bootstrap message
// box over `/common/templates/message.dialog.tpl.html`.
//
// The extension's own `showAlert` (`chrome-extension.run.ng1.ts:22`) opens the same template with
// `windowClass: 'alert-dialog'`, which is what this renders. That class is also what the baseline
// capture refuses to photograph, so a screen showing this is never filed as a reference.
//
// ⚠️ `.modal-content` IS NESTED, AND THAT IS uib's SHAPE, NOT A MISTAKE. `$uibModal` wraps every
// template in `.modal-dialog.modal-<size> > .modal-content`, and this template's own root is
// another `.modal-content.noborder`. Collapsing the two would change which border and shadow show.
import type { ReactElement } from 'react'
import { useModalLayer } from '../modal/modalStack.ts'

export interface MessageDialogProps {
  text: string
  okLabel: string
  /** uib's `size` — `modal-<size>` on the dialog. */
  size?: 'sm' | 'md' | 'lg'
  onOk: () => void
}

export function MessageDialog({ text, okLabel, size, onOk }: MessageDialogProps): ReactElement {
  // One backdrop for the whole stack, beneath the top modal — see `modalStack.ts`.
  const layer = useModalLayer(true)
  return (
    <>
      {layer.backdropZIndex === undefined ? null : (
        <div className="modal-backdrop fade in" style={{ zIndex: layer.backdropZIndex }} />
      )}
      <div className="modal fade alert-dialog in" role="dialog" style={{ display: 'block', zIndex: layer.windowZIndex }}>
        <div className={`modal-dialog${size === undefined ? '' : ` modal-${size}`}`}>
          <div className="modal-content">
            <div className="modal-content noborder">
              <div className="modal-header">
                <button type="button" className="close" onClick={onOk}>
                  <span aria-hidden="true">&times;</span>
                  <span className="sr-only">{okLabel}</span>
                </button>
                <h4 className="modal-title" />
              </div>
              <div className="modal-body">{text}</div>
              <div className="modal-footer">
                <button type="button" className="btn btn-success" data-dismiss="modal" onClick={onOk}>
                  {okLabel}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
